export default "__VITE_ASSET__DEsBXrYv__"